import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { isNull } from 'lodash'
import FavoriteBorder from 'material-ui/svg-icons/action/favorite-border'
import ListCard from '../../common/ListCard'
import NoResults from '../../common/NoResults'
import ListCardVirtual from '../../common/ListCardVirtual'
import {
  loadWantedItems,
  loadMoreWantedItems,
  unloadWantedItems,
  putWantedItemsInCache,
} from '../../actions'
import {
  getWantedItems,
  canLoadMoreWantedItems,
  getTotalWantedItems,
  getWantedItemsLoading,
  getWantedItemsScrollToIndex,
} from '../../selectors'
import {
  parseQ,
  itemLink,
  getLocationKey,
  adjustScrollToIndex,
} from '../../utils'
import { themeColors } from '../../styles/theme'

const styles = {
  favoriteBorder: {
    color: themeColors.positive,
    position: 'relative',
    top: 7,
  },
}

class WantedItems extends PureComponent {
  state = {
    scrollToIndex: undefined,
  }

  componentDidMount() {
    const { items, scrollToIndex } = this.props
    if (scrollToIndex && items) {
      // Living in a life of workaround
      this.setState({
        scrollToIndex: adjustScrollToIndex(scrollToIndex, items.length),
      })
    }
    this.props.loadWantedItems(
      {
        q: this.props.searchString,
      },
      getLocationKey(this.props.location)
    )
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.searchString !== nextProps.searchString) {
      this.props.unloadWantedItems()
      this.props.loadWantedItems({
        q: nextProps.searchString,
      })
    }
  }

  componentWillUnmount() {
    this.props.unloadWantedItems(false)
  }

  componentDidUpdate(prevProps, prevState) {
    // Scroll resetted can now purge it!
    if (prevState.scrollToIndex) {
      this.setState({ scrollToIndex: undefined })
    }
  }

  loadMore = () => {
    this.props.loadMoreWantedItems({
      q: this.props.searchString,
    })
  }

  goToItemDetail = (item, index) => {
    this.props.putWantedItemsInCache({
      index,
      cacheKey: getLocationKey(this.props.location),
    })
    this.props.history.push(itemLink(item))
  }

  renderNoRows = () => {
    const { items, loading, searchString } = this.props

    if (!loading && !isNull(items) && items.length === 0) {
      if (searchString === '') {
        // No items wanted
        return (
          <NoResults>
            Naviga tra le categorie e clicca su
            {' '}
            <FavoriteBorder style={styles.favoriteBorder} />
            {' '}
            per aggiungere oggetti
          </NoResults>
        )
      } else {
        // No results for searching
        return (
          <NoResults>
            Nessun oggetto per la ricerca <b><i>{searchString}</i></b>
          </NoResults>
        )
      }
    }
    return null
  }

  render() {
    const { items, loading, canLoadMoreItems } = this.props
    return (
      <ListCardVirtual
        items={items}
        loading={loading}
        canLoadMoreItems={canLoadMoreItems}
        loadMore={this.loadMore}
        scrollToIndex={this.state.scrollToIndex}
        noRowsRenderer={this.renderNoRows}
        renderListCard={(item, index) => (
          <ListCard item={item} index={index} onClick={this.goToItemDetail} />
        )}
      />
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  // Parse the query string ?q= into a string take care of null boring stuff
  searchString: parseQ(ownProps.location),
  items: getWantedItems(state, getLocationKey(ownProps.location)),
  totalItems: getTotalWantedItems(state),
  canLoadMoreItems: canLoadMoreWantedItems(state),
  loading: getWantedItemsLoading(state),
  scrollToIndex: getWantedItemsScrollToIndex(
    state,
    getLocationKey(ownProps.location)
  ),
})

export default connect(mapStateToProps, {
  loadWantedItems,
  loadMoreWantedItems,
  unloadWantedItems,
  putWantedItemsInCache,
})(WantedItems)



// WEBPACK FOOTER //
// ./src/pages/Me/WantedItems.js